const fetchStoryWithRetry = async (url, slug, retries = 3, delay = 1000) => {
  //console.log(url,slug);
  for (let i = 0; i < retries; i++) {
    try {
      if(i === 0 && url === 'https://eurodressage.com/api/ed/home/one' ){
      console.log(`%c
        ,--,
  _ ___/ /\\|
 ;( )__, )
; //   '--;
  \\     |
   ^     ^ Rémi Blot - remiblot.com`, `font-family: monospace` );
  }

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      // Check if the response is actually JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Expected JSON but received:', contentType, 'Content:', text.substring(0, 200));
        throw new Error(`Expected JSON but received ${contentType || 'unknown content type'}`);
      }

      return await response.json();

    } catch (error) {
      console.error(`Attempt ${i + 1} failed for URL: ${url}`, error);
      if (i < retries - 1) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      } else {
        throw error;
      }
    }
  }
};

export default fetchStoryWithRetry;
